var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid fid-card" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "col-xs-12 flex-around-center" }, [
      _c(
        "a",
        { attrs: { href: _vm.location.origin + _vm.to } },
        [
          _c("VueQr", {
            attrs: { size: 175, text: _vm.location.origin + _vm.to },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-12" }, [
      _c("h2", { staticClass: "text-center" }, [
        _vm._v("Scannez ce code pour créer une carte de fidélité"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }